import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import { PdpSharedDetail } from './PdpSharedDetail';
import { PdpSharedDetailItemInvoice } from './PdpSharedDetailItemInvoice';
import { PdpSharedDetailReference_item } from './__generated__/PdpSharedDetailReference_item.graphql';
import { PdpSharedDetailReference_user } from './__generated__/PdpSharedDetailReference_user.graphql';
import { PdpSharedDetailReference_viewer } from './__generated__/PdpSharedDetailReference_viewer.graphql';

type Props = {
    detailValues: string[];
    delimiter?: string;
    currency?: string;
    skuId: string;
    item: PdpSharedDetailReference_item;
    viewer: PdpSharedDetailReference_viewer;
    user: PdpSharedDetailReference_user;
    hideInvoice: boolean;
};

const PdpSharedDetailReferenceComponent: FC<Props> = props => {
    const { detailValues, currency, delimiter, skuId, item, viewer, user, hideInvoice } = props;
    const {
        isAvailable,
        isSold,
        hasPrivateListing,
        hasActiveHoldForBuyer,
        isListingUnlisted,
        seller,
    } = item || {};
    const showInvoice =
        viewer.isItemInvoiceEnabled &&
        (isAvailable || hasActiveHoldForBuyer) &&
        !isSold &&
        !hasPrivateListing &&
        !hideInvoice &&
        !isListingUnlisted &&
        seller?.isAccessible;
    return (
        <>
            <PdpSharedDetail
                detailValues={detailValues}
                currency={currency}
                delimiter={delimiter}
                selectedSkuId={skuId}
            />
            {showInvoice && <PdpSharedDetailItemInvoice item={item} skuId={skuId} user={user} />}
        </>
    );
};

export const PdpSharedDetailReference = createFragmentContainer(PdpSharedDetailReferenceComponent, {
    viewer: graphql`
        fragment PdpSharedDetailReference_viewer on Viewer {
            isItemInvoiceEnabled: isEnabledByLocale(featureName: "INVOICE")
        }
    `,
    item: graphql`
        fragment PdpSharedDetailReference_item on Item {
            isAvailable
            isSold
            hasPrivateListing
            isListingUnlisted
            hasActiveHoldForBuyer(buyerId: $userId) @include(if: $fetchUser)
            seller {
                isAccessible
            }
            ...PdpSharedDetailItemInvoice_item
        }
    `,
    user: graphql`
        fragment PdpSharedDetailReference_user on User {
            ...PdpSharedDetailItemInvoice_user
        }
    `,
});
